import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { getHeaderHeight } from '../navigation/header/header.utils';
import { hex2rgba } from '../../../theming/theming.utils';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'authorTopGradient';

interface AuthorTopGradientDataProps {
  isSecondaryHeaderEnabled: boolean;
}

interface AuthorTopGradientThemeProps {
  baseUnit: BaseUnit;
  color: string;
}

const getOverlayHeight = (baseUnit: BaseUnit, imageHeight: number, menuHeight: number) => {
  return baseUnit * 2.5 + imageHeight / 2 + menuHeight;
};

const getStyles = (baseUnit: BaseUnit, color: string, headerHeight: number) => StyleSheet.create({
  wrapper: {
    position: 'absolute',
    background: `linear-gradient(0deg, rgba(0,0,0,0) 0%, ${hex2rgba(color, 1)} 100%)`,
    top: 0,
    left: 0,
    right: 0,
    [MEDIA_BREAKPOINTS.large]: {
      height: `${getOverlayHeight(baseUnit, 160, headerHeight)}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      height: `${getOverlayHeight(baseUnit, 120, headerHeight)}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      height: `${getOverlayHeight(baseUnit, 120, headerHeight)}px`,
    },
  },
});

export const AuthorTopGradient: React.FunctionComponent<AuthorTopGradientDataProps> = props => {
  const { isSecondaryHeaderEnabled } = props;
  const { baseUnit, color } = useTheme<AuthorTopGradientThemeProps>(componentConfigThemeKey);
  const headerHeight = getHeaderHeight(isSecondaryHeaderEnabled);
  const styles = getStyles(baseUnit, color, headerHeight);

  return <ErrorBoundary><div className={css(styles.wrapper)} /></ErrorBoundary>;
};
